import { css, keyframes } from 'goober';
import { isNumber, noop } from 'mc-ui-utils';
import React, { memo, useCallback, useMemo } from 'react';
import constants from '../../constants';
import State from '../../state';
import colors from '../../styles/colors';
import { transparentize } from '../../styles/mixins';
const storyProgressAnimation = keyframes `
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`;
const Story = css `
  background: ${transparentize(0.5, colors.white)};
  border-radius: 4px;
  height: 2px;
  position: relative;
  flex: 1;
  margin: 0 1px;
  &.holding {
    opacity: 0;
  }
`;
const Progress = css `
  position: absolute;
  height: 100%;
  background: ${colors.white};
  width: 100%;
`;
const EmptyBar = css `
  width: 0;
`;
const Progressing = css `
  transform: scaleX(0);
  animation-iteration-count: 1;
  animation-timing-function: linear;
  transform-origin: left;
`;
const StoryProgress = (props) => {
    const { glanceId, glanceIndex, storyIndex, cardIndex, highlightIndex, isAutoPlayPaused, onEnd, hasAudio, isHolding, isYoutube, } = props;
    const timePassed = State.getVideoTimeline(glanceId) * 1000;
    let videoDurationNotAvailable = false;
    let duration = constants.STORY_PLAYER_DURATION;
    if (hasAudio && State.checkGlanceStatesAvailable(glanceId)) {
        if (State.getVideoDuration(glanceId)) {
            duration = State.getVideoDuration(glanceId);
        }
        else if (!isYoutube) {
            videoDurationNotAvailable = true;
        }
    }
    const hasSeen = storyIndex < highlightIndex;
    const iscurrentCard = cardIndex === glanceIndex;
    const isActive = iscurrentCard && storyIndex === highlightIndex;
    const onAnimationEnd = useCallback((e) => {
        if (e.elapsedTime > 0) {
            'requestIdleCallback' in window
                ? window.requestIdleCallback(() => {
                    State.setVideoTimeline(glanceId, 0);
                })
                : State.setVideoTimeline(glanceId, 0);
            onEnd();
        }
    }, [glanceId, onEnd]);
    const animationStyle = useMemo(() => {
        let style = {};
        if (isActive) {
            style = Object.assign(Object.assign({}, style), { animationPlayState: !isAutoPlayPaused && !videoDurationNotAvailable
                    ? 'running'
                    : 'paused', animationDuration: `${duration}ms`, animationDelay: isNumber(timePassed) ? `-${timePassed}ms` : '0ms' });
            style.animationName = storyProgressAnimation;
        }
        return Object.assign({}, style);
    }, [
        duration,
        isActive,
        isAutoPlayPaused,
        timePassed,
        videoDurationNotAvailable,
    ]);
    const cssClasses = useMemo(() => {
        const arr = ['progress', Progress];
        if (isActive) {
            arr.push(Progressing);
        }
        if (!hasSeen && !isActive) {
            arr.push(EmptyBar);
        }
        return arr;
    }, [isActive, hasSeen]);
    return (React.createElement("div", { className: `${Story}${isHolding ? ' holding' : ''}`, key: glanceId },
        React.createElement("div", { onAnimationEnd: iscurrentCard ? onAnimationEnd : noop, "data-card": glanceId, className: cssClasses.join(' '), style: animationStyle })));
};
const shouldNotReRender = (prevProps, nextProps) => {
    const hasAutoPlayChanged = prevProps.isAutoPlayPaused !== nextProps.isAutoPlayPaused;
    const hasHoldingChanged = prevProps.isHolding !== nextProps.isHolding;
    const isCurrentProgressbar = nextProps.glanceIndex === nextProps.cardIndex &&
        nextProps.storyIndex === nextProps.highlightIndex;
    const wasAProgressbar = prevProps.glanceIndex === prevProps.cardIndex &&
        prevProps.storyIndex === prevProps.highlightIndex;
    return !(hasAutoPlayChanged ||
        isCurrentProgressbar !== wasAProgressbar ||
        hasHoldingChanged);
};
export default memo(StoryProgress, shouldNotReRender);
//# sourceMappingURL=index.js.map